import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {catchError, Observable, of, switchMap} from 'rxjs';
import {UserService} from '../services/user.service';
import {UserStateService} from '../states/user-state.service';
import {UserLinksStateService} from '../states/user-links-state.service';
import {UserInterfaces} from '../interfaces/user.interfaces';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(
    private userState: UserStateService,
    private userService: UserService,
    private router: Router,
    private state: UserLinksStateService
  ) {}

  canActivate(): Observable<boolean> {
    const user = this.userState.user();
    const userLinks = this.state.userLinks();

    if (userLinks?.totalCount < 0) {
      return this.userService.getUserNavigation().pipe(
        switchMap(links => {
          this.state.userLinks.set(links);
          return this.getData$(user);
        }));
    }

    return this.getData$(user);
  }

  private getData$(user: UserInterfaces) {
    if (user && 'isAdmin' in user) {
      return this.checkAccess(user);
    }

    return this.userService.getUser().pipe(
      switchMap(fetchedUser => {
        this.userState.user.set(fetchedUser);
        return this.checkAccess(fetchedUser);
      }),
      catchError(() => {
        this.router.navigate(['/no-access']);
        return of(false);
      })
    );
  }

  private checkAccess(user: any): Observable<boolean> {
    if (user.isAdmin) {
      return of(true);
    } else {
      this.router.navigate(['/no-access']);
      return of(false);
    }
  }
}
